/**
 * Roxy Experience URL Parameter Detection
 * Checks for ?experience=women or experience=men and applies a theme class to the body
 */
export const roxy = () => {
  const body = document.body;
  const urlParams = new URLSearchParams(window.location.search);
  const experience = urlParams.get('experience');

  if (!experience) {
    return;
  }
  for (const className of body.classList) {
    if (className.startsWith('color-scheme-')) {
      body.classList.remove(className);
      break;
    }
  }
  let roxyClasses;
  if (experience.toLowerCase().includes('women')) {
    roxyClasses = ['womens-theme', body.dataset.roxyWomensTheme || ''];
  }
  else if(experience.toLowerCase().includes('men')) {
    roxyClasses = ['mens-theme', body.dataset.roxyMensTheme || ''];
  }
   if (roxyClasses) body.classList.add(...roxyClasses);
};
